export default __webpack_public_path__ + "static/media/img-smiley-color.06dda6d4.svg";